const Icon: React.FC = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_415_16890)">
        <path
          d="M23.5 13.5L23.5 8.50001M23.5 8.50001H18.5M23.5 8.50001L16 16M14.3333 8.5H12.5C11.0999 8.5 10.3998 8.5 9.86502 8.77248C9.39462 9.01217 9.01217 9.39462 8.77248 9.86502C8.5 10.3998 8.5 11.0999 8.5 12.5V19.5C8.5 20.9001 8.5 21.6002 8.77248 22.135C9.01217 22.6054 9.39462 22.9878 9.86502 23.2275C10.3998 23.5 11.0999 23.5 12.5 23.5H19.5C20.9001 23.5 21.6002 23.5 22.135 23.2275C22.6054 22.9878 22.9878 22.6054 23.2275 22.135C23.5 21.6002 23.5 20.9001 23.5 19.5V17.6667"
          stroke="currentColor"
          stroke-width="2.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_415_16890"
          x="-2"
          y="-1"
          width="36"
          height="36"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_415_16890"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_415_16890"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default Icon
